module.exports = __webpack_public_path__ + "20128f3b37b39335de79f57748fe81f7.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/fontello/fontello.ttf?67495670
// module id = 8040
// module chunks = 0